document.addEventListener("DOMContentLoaded", async () => {
    const loader = document.getElementById("tangent-loader");
    const error = document.getElementById("tangent-error");

    const respId = new URLSearchParams(window.location.search).get("resp_id");

    if (!respId) {
        loader.style.display = "none";
        error.style.display = "block";
        error.textContent = "Missing resp_id.";
        return;
    }

    try {
        const apiUrl = `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${respId}&self_serve=true`;

        const response = await fetch(apiUrl);

        if (!response.ok) {
            throw new Error("Failed to fetch recommendations.");
        }

        const data = await response.json();

        console.log(data.products[0]);

        loader.style.display = "none";

        renderDescription(data.description);

        renderProductSections(
            data.product_sections || {},
            data.products || [],
            data.selected_variants || {}
        );

    } catch (err) {
        console.error(err);

        loader.style.display = "none";
        error.style.display = "block";
        error.textContent = "Unable to load recommendations.";
    }
});

function renderDescription(description) {
    const container = document.getElementById("tangent-description");

    if (!container || !description) return;

    container.innerHTML = description;
}

function renderProductSections(productSections, products, selectedVariants) {

    const container = document.getElementById("tangent-products");

    if (!container) {
        console.error("Missing #tangent-products");
        return;
    }

    container.innerHTML = "";

    for (const sectionName in productSections) {

        console.log(sectionName)

        const section = document.createElement("div");
        section.className = "tangent-product-section";

        // Heading
        if (sectionName !== "section_primary_products"){
        const heading = document.createElement("h2");

        heading.className = "tangent-section-heading";

        heading.innerText ="STILL NOT SURE...";
        
        section.prepend(heading);
        }

        // Grid
        const grid = document.createElement("div");
        grid.className = "tangent-product-grid";

        productSections[sectionName].forEach(productId => {

            const product = products.find(
                p => String(p.id) === String(productId)
            );

            if (!product) return;

            const selectedVariantIds = selectedVariants[String(product.id)] || [];

            const variantId =
                sectionName === "section_primary_products"
                    ? selectedVariantIds[0]
                    : selectedVariantIds[1];
            
            const variant =
                product.variants.find(
                    v => String(v.id) === String(variantId)
                ) || product.variants[0];


            const card = document.createElement("div");
            card.className = "tangent-product-card";

            const variantTitle = variant?.title || "";

            card.innerHTML = `
              <a href="/products/${product.handle}"
              target="_blank"
              rel="noopener noreferrer">
    <img
        src="${product.image?.src || product.images?.[0]?.src || ""}"
        alt="${product.title}"
    >
</a>
               <a href="/products/${product.handle}"
               target="_blank"
                rel="noopener noreferrer"
                class="product-link">
    <div class="product-name">
        ${product.title.toUpperCase()}
    </div>
</a>

     <div class="variant-title">
        ${variant?.title || ""}
    </div>

               <div class="product-price">
        $${variant.price}
    </div>

                <button
                    class="add-to-cart"
                    data-id="${variant?.id}">
                    Add to Cart
                </button>
            `;

            grid.appendChild(card);

        });

        section.appendChild(grid);

        container.appendChild(section);
    }
}

// Add to Cart
document.addEventListener("click", async (e) => {

    if (!e.target.classList.contains("add-to-cart")) return;

    const variantId = e.target.dataset.id;

    try {

        await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });

        e.target.innerText = "Added";

    } catch (err) {
        console.error(err);
    }

});